import { BillStatusType, BaseRowStore } from './BaseRowStore'

export class ToolBarStore {
  private rowStore: BaseRowStore<any>;

  constructor(rowStore: BaseRowStore<any>) {
    this.rowStore = rowStore;
  }

  getVerifyState() {
    const verifyState = this.rowStore.data?.verifyState;
    if (!verifyState) {
      return '';
    }
    return verifyState.toString();
  }

  isAudit(state: string) {
    return state === BillStatusType.AUDIT
  }

  isOpen(state: string) {
    return state === BillStatusType.OPEN
  }

  isStop(state: string) {
    return state === BillStatusType.STOP
  }

  isDisapproveDraft(state: string) {
    return state === BillStatusType.DisapproveDraft
  }

  hasVerifyState(state: string) {
    return !state || this.isOpen(state) || this.isStop(state) || this.isDisapproveDraft(state);
  }

  get btnEditWithApproveStatus() {
    // 行内编辑-审批中显示
    const verifyState = this.getVerifyState();
    return this.hasVerifyState(verifyState) || this.isAudit(verifyState);
  }

  get btnDeleteVisible() {
    // 行内删除
    const verifyState = this.getVerifyState();
    return this.hasVerifyState(verifyState);
  }

  /**
   * 行内编辑按钮显示控制
   */
  get btnEditVisible() {
    // 邓娟说审批中编辑按钮不显示了
    const verifyState = this.getVerifyState();
    return this.hasVerifyState(verifyState);
  }
}